import { combineReducers } from 'redux';

import GetPath from './general/get_path';
import GetUiRed from './general/get_ui_red';
import GetCategory from './general/get_category';
import GetUnsur from './general/get_unsur';
import GetUnsurAll from './general/get_unsur_all';
import GetDictionary from './general/get_dictionary';
import GetCategorySelected from './general/get_category_selected';
import GetUnsurResultDic from './general/get_unsur_result_dic';
import GetUnsurResultAll from './general/get_unsur_result_all';
import GetUnsurSelected from './general/get_unsur_selected';
import GetUserId from './general/get_user_id';
import GetSearchText from './general/get_search_text';
import GetObject from './general/get_object';

const rootReducer = combineReducers({
    path: GetPath,
    ui_red: GetUiRed,
    category: GetCategory,
    unsur: GetUnsur,
    unsurall: GetUnsurAll,
    dictionary: GetDictionary,
    categorySelected: GetCategorySelected,
    unsurSelected: GetUnsurSelected,
    unsurResultDic: GetUnsurResultDic,
    unsurResultAll: GetUnsurResultAll,
    userID: GetUserId,
    searchText: GetSearchText,
    object: GetObject
  });

export default rootReducer;
